/**
 * /app/audit — tenant-wide entry into the audit log.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/audit')({
  component: () => (
    <TrustScopedLanding
      suffix="audit"
      eyebrow="Audit log"
      title="Audit log"
      activeNav="audit"
      emptyHelp="The audit log records every state-changing action on your trust: resolutions signed, beneficial-ownership updates, distributions, and lifecycle events. It begins recording once you onboard a trust."
    />
  ),
});
